import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";
import { AbstractTypeMediaData, AbstractTypeMediaSchema } from "../abstract";

export interface AbstractUploadsData {
    abstractId: number;
    typeMedia: AbstractTypeMediaData[];
}

export class AbstractUploads implements FormValidationModel<AbstractUploadsData> {
    public data: AbstractUploadsData;
    public rules: yup.Schema<AbstractUploadsData>;

    public constructor() {
        this.data = {
            abstractId: 0,
            typeMedia: [],
        };
        this.rules = yup.object<AbstractUploadsData>().shape({
            abstractId: yup.number().required().label("Abstract ID").min(0, "Invalid $label"),
            typeMedia: yup.array().of(AbstractTypeMediaSchema).label("Media categories"),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/adminAbstracts/AbstractUploads.ts